export default __webpack_public_path__ + "static/media/btn-more.782143bc.png";